import React, { useState, useEffect, useRef } from "react";
import { createFilter } from "react-select";
import AgentService from "core/api/AgentService";
import AsyncSelect from "react-select/async";
import { Button } from "reactstrap";

export const AddressSelectorInputComponent = ({
  value,
  setValue,
  setUnknownBuildingAddress
}) => {
  const [selected, setSelected] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const selectRef = useRef(null);

  const filterAddresses = async (inputValue) => {
    const responseData = await AgentService.getBuildingsByAddress(inputValue);

    if (responseData.model.length === 0) return null;

    return responseData.model.map((building) => ({
      value: building.id,
      label: `${building.line1}, ${building.city}, ${building.state} ${building.postalCode}`,
    }));
  };

  const loadOptions = (inputValue, callback) => {
    setTimeout(async () => {
      var items = await filterAddresses(inputValue);
      callback(items);
    }, 1000);
  };

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
  };

  useEffect(() => {
    async function fetchData() {
      const building = await AgentService.getBuilding(value)
      setSelected({ value: value, label: `${building.line1}, ${building.city}, ${building.state} ${building.postalCode}` })
      setInputValue(`${building.line1}, ${building.city}, ${building.state} ${building.postalCode}`)
    }
    if (value) {
      fetchData();
    }
  }, [])


  return (
    <AsyncSelect
      ref={selectRef}
      value={selected}
      filterOption={createFilter(filterConfig)}
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      onChange={(option) => {
        setValue(option?.value)
        setSelected(option)
        setInputValue(option?.label)
        setUnknownBuildingAddress(null)
      }}
      onInputChange={(input, { action }) => {
        setInputValue(input);
      }}
      getOptionLabel={(option) => `${option.label}`}
      isClearable
      placeholder="Search for address"
      noOptionsMessage={() => (
        <div style={{ textAlign: 'center', padding: 8 }}>
          <Button
            color="primary"
            onClick={() => {
              setSelected({ value: null, label: inputValue });
              setUnknownBuildingAddress(inputValue);
              selectRef.current?.blur();
            }}
          >
            Unknown Building Address
          </Button>
        </div>
      )}
    />

  );
};
